<template>
  <div class="card modal-overflow" style="box-shadow: none;">
    <div class="card-body new-project">
      <div class="row">
        <div class="col-md-5">
          <div class="form-group">
            <label>Project Name</label>
            <div class="project-view-fields grey-font">
              <h6>
                {{ project.name }}
              </h6>
            </div>
          </div>
        </div>
        <div class="col-md-1">
          <label>&nbsp</label>
          <img @click.stop="viewFiles" v-if="canReadFiles" src="static/img/icon-folder.png" title="Project Files" class="files-icon"/>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Project Type</label>
            <div class="project-view-fields grey-font">
              {{ project.projectType }}
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Departments</label>
            <div class="project-view-fields grey-font">
              {{ project.departmentsNames | toCsv }}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label>City</label>
            <div class="project-view-fields grey-font">
              {{ lodash.get(project, 'address.city') }}
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Street Number</label>
            <div class="project-view-fields grey-font">
              {{ lodash.get(project, 'address.streetNumber') }}
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Street Name</label>
            <div class="project-view-fields grey-font">
              {{ lodash.get(project, 'address.streetName') }}
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>County</label>
            <div class="project-view-fields grey-font">
              {{ lodash.get(project, 'address.county') }}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label>Building Number</label>
            <div class="project-view-fields grey-font">
              {{ lodash.get(project, 'address.buildingNumber') }}
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Floor Number</label>
            <div class="project-view-fields grey-font">
              {{ lodash.get(project, 'address.floorNumber') }}
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Suite Number</label>
            <div class="project-view-fields grey-font">
              {{ lodash.get(project, 'address.suiteNumber') }}
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Jurisdiction</label>
            <div class="project-view-fields grey-font">
              {{ lodash.get(project, 'address.jurisdiction') }}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label>State</label>
            <div class="project-view-fields grey-font">
              {{ lodash.get(project, 'address.state') }}
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Zip</label>
            <div class="project-view-fields grey-font">
              {{ lodash.get(project, 'address.zip') }}
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Lot Number</label>
            <div class="project-view-fields grey-font">
              {{ lodash.get(project, 'address.lotNumber') }}
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Block Number</label>
            <div class="project-view-fields grey-font">
              {{ lodash.get(project, 'address.blockNumber') }}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label>Section</label>
            <div class="project-view-fields grey-font">
              {{ lodash.get(project, 'address.section') }}
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Phase</label>
            <div class="project-view-fields grey-font">
              {{ lodash.get(project, 'address.phase') }}
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Legal Subdivision</label>
            <div class="project-view-fields grey-font">
              {{ lodash.get(project, 'address.legalSubdivision') }}
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Legal Description</label>
            <div class="project-view-fields grey-font">
              {{ lodash.get(project, 'address.legalDescription') }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {OK} from 'http-status-codes'
import {notifyError, objectNamesById, fileSystemPath} from 'src/utilities/utils'
import lodash from 'lodash'
import Permissions from 'src/utilities/permissions'

export default {
  props: ['data'],
  computed: {
    departments() {
      return this.$store.get('departments/results')
    },
    canReadFiles() {
      return this.$can('read', Permissions.FILES);
    }
  },
  data() {
    return {
      lodash,
      project: {}
    }
  },
  methods: {
    async viewFiles() {
      const projectResponse = await this.$store.dispatch('projects/fetchById', this.project.id)
      if (OK !== projectResponse.status) {
        notifyError(this, "Failed to load project by ID: " + this.project.id)
        return
      }

      const path = fileSystemPath(projectResponse.data.name, this.project.id)
      this.$eventHub.$emit('show-modal-4', 'File Browser', path, '600px')
    },
  },
  async mounted() {
    if (!lodash.get(this.data, 'id')) {
      notifyError(this, 'The `this.data.id` prop is missing. Unable to load project data.')
      return
    }

    const response = await this.$store.dispatch('fetchById', {
      'endpoint': 'projects',
      'id': this.data.id
    })

    if (OK === response.status) {
      this.project = response.data
      this.project.departmentsNames = objectNamesById(this.departments, this.project.departments)
    }
  }
}
</script>

<style scoped>
  .project-view-fields {
    background-color: lightgrey;
    padding: 11px 0 4px 8px;
    border-radius: 5px;
    min-height: 40px;
  }

  label {
    display: block;
  }

  .files-icon {
    cursor: pointer;
    margin-top: 8px;
  }
</style>
